import { Divider } from 'antd'
import React, { useState, useEffect } from 'react'
import { CustomCard, CustomTable } from 'src/components'
import { Campaign, DiscountVoucher } from 'src/core/models'
import { getDiscountVouchersFiltered } from 'src/core/helpers'
import { discountVoucherColumns } from 'src/core/table-columns'
import DiscountVouchersListHeader from './DiscountVouchersListHeader/DiscountVouchersListHeader'

const DiscountVouchersList: React.FC<{ campaign: Campaign }> = (props) => {
  const { campaign } = props
  const { discount_vouchers: discountVouchers } = campaign

  const [text, setText] = useState<string>(null)
  const [filteredDiscountVouchers, setFilteredDiscountVouchers] = useState<DiscountVoucher[]>(discountVouchers)

  useEffect(() => {
    const newDiscountVouchersFiltered = getDiscountVouchersFiltered(text, discountVouchers)
    setFilteredDiscountVouchers(newDiscountVouchersFiltered)
  }, [text, discountVouchers])


  const tableProps = {
    dataSource: filteredDiscountVouchers,
    columns: discountVoucherColumns,
    rowKey: (discountVoucher: DiscountVoucher) => discountVoucher.id,
    rowClassName: 'fade-animation',
  }

  return (
    <div className='collapse-animation'>
      <CustomCard>

        {/* Header */}
        <DiscountVouchersListHeader
          text={text}
          campaign={campaign}
          onTextChange={(value) => setText(value)}
        />
        <Divider />

        {/* Table */}
        <CustomTable {...tableProps} />
      </CustomCard>
    </div>
  )
}

export default DiscountVouchersList
